import { KeyValueOf } from '../common';
import { AdditionalPropertyOfAdditionalProperty } from './additionalProperties';
import { AdditionalPropertyOfAdditionalPropertyGroup } from './additionalPropertyGroup';
import { AdditionalPropertyOfAdditionalPropertyValue } from './additionalPropertyValues';
import { AdditionalPropertyOfAddressCountry } from './addressCountry';
import { AdditionalPropertyOfAddressRequirements } from './addressRequirements';
import { AdditionalPropertyOfAddressStateProvinceRegion } from './addressStateProvinceRegion';
import { AdditionalPropertyOfAdjustmentReason } from './adjustmentReason';
import { AdditionalPropertyOfAwsLambdaConfiguration } from './awsLambdaConfiguration';
import { AdditionalPropertyOfBusinessUnitTemplate } from './businessUnitTemplate';
import { AdditionalPropertyOfContactEvent } from './codeTableContactEvent';
import { AdditionalPropertyOfContactMapping } from './codeTableContactMapping';
import { AdditionalPropertyOfCodeTableExternalReferenceType } from './codeTableExternalReferenceType';
import { AdditionalPropertyOfCodeType } from './codeType';
import { AdditionalPropertyOfConsents } from './consents';
import { AdditionalPropertyOfConvergentBillerDefaultBehavior } from './convergentBillerDefaultBehavior';
import { AdditionalPropertyOfCountryCurrency } from './countryCurrency';
import { AdditionalPropertyOfCustomBillerRuleConfiguration } from './customBillerRuleConfiguration';
import { AdditionalPropertyOfDeliveryCapabilityToBillerRuleConfiguration } from './deliveryCapabilityToBillerRuleConfiguration';
import { AdditionalPropertyOfEarlyTerminationFeeBillerRuleConfiguration } from './earlyTerminationFeeBillerRuleConfiguration';
import { AdditionalPropertyOfEntitlementBillerRuleConfiguration } from './entitlementBillerRuleConfiguration';
import { AdditionalPropertyOfEnvironmentCopySettings } from './environmentCopySettings';
import { AdditionalPropertyOfFeatureToggle } from './featureToggle';
import { AdditionalPropertyOfFeatureType } from './featureType';
import { AdditionalPropertyOfFinanceBillerRuleConfiguration } from './financeBillerRuleConfiguration';
import { AdditionalPropertyOfGiftCardConfiguration } from './giftCardConfiguration';
import { AdditionalPropertyOfInteractionCategory } from './interactionCategory';
import { AdditionalPropertyOfInteractionType } from './interactionType';
import { AdditionalPropertiesOfMicroserviceRouting } from './miroserviceRouting';
import { AdditionalPropertyOfPaymentInstrumentConfiguration } from './paymentInstrumentConfiguration';
import { AdditionalPropertyOfPaymentInstrumentType } from './paymentInstrumentType';
import { AdditionalPropertyOfProductLineBusinessDeliveryCapability } from './productLineOfBusinessDeliveryCapability';
import { AdditionalPropertyOfQuoteAndOrder } from './quoteAndOrderConfiguration';
import { AdditionalPropertiesOfReasonCodes } from './reasonCodes';
import { AdditionalPropertyOfRecurringBillerRuleConfiguration } from './recurringBillerRuleConfiguration';
import { AdditionalPropertyOfRegularExpression } from './regularExpression';
import { AdditionalPropertiesOfServiceabilityAndVerifications } from './serviceabilityAndVerification';
import { AdditionalPropertyOfServiceAttribute } from './serviceAttribute';
import { AdditionalPropertyOfShippingAddressProvider } from './shippingAddressProvider';
import { AdditionalPropertyOfSubscriberIdentifications } from './subscriberIdentifications';
import { AdditionalPropertyOfSubscriberType } from './subscriberType';
import { AdditionalPropertyOfSubscriberTypeSecurityRole } from './subscriberTypeSecurityRole';
import { AdditionalPropertyOfTermsAndConditionsConfiguration } from './termsAndConditionsConfiguration';
import { AdditionalPropertyOfTermsAndConditionsType } from './termsAndConditionsType';
import { AdditionalPropertyOfTriggerBillerRuleConfiguration } from './triggerBillerRuleConfiguration';
import { AdditionalPropertyOfUsageBillerRuleConfiguration } from './usageBillerRuleConfiguration';

export enum CodeTableNumber {
  AccountCategory = 499,
  AccountClass = 498,
  Accounting = 595,
  AccountingMethod = 594,
  AccountUpdaterExecutionStatus = 248,
  ActivityStatus = 400,
  ActivityType = 401,
  AdditionalProperty = 4,
  AdditionalPropertyGroup = 186,
  AdditionalPropertyValue = 179,
  AdditionalPropertyValueType = 5,
  AddressCountry = 59,
  AddressRequirements = 556,
  AddressStateProvinceRegion = 60,
  AddressType = 393,
  AddressValidationBusinessUnitSettings = 534,
  AddressValidationProvider = 711,
  AdGroup = 462,
  AdjustmentConfig = 601,
  AdjustmentReason = 391,
  AdjustmentType = 390,
  AdTagKey = 124,
  AdTagKeyType = 127,
  AggregateFrequency = 667,
  AggregateGrouping = 662,
  AggregateLevel = 664,
  AggregateResult = 663,
  AggregationType = 665,
  AgreementExternalReferenceType = 745,
  AllCountry = 216,
  AllowanceTax = 750,
  AllowlistAddReason = 250,
  AllowlistRemoveReason = 251,
  AmazonSnsConfiguration = 469,
  AnonymousProxyRestrictionSettings = 191,
  AutomaticAnonymization = 281,
  AutopayConfig = 507,
  AVSDeclineConfiguration = 229,
  BalanceAdjustmentReason = 270,
  BatchPaymentStatus = 246,
  BillerRuleInstanceAdditionalIdentifierType = 689,
  BillRunStatus = 466,
  BillRunType = 461,
  BlocklistAddReason = 252,
  BlocklistRemoveReason = 253,
  BraintreeMethodType = 443,
  BrandableCurrency = 37,
  BrandableCurrencyChargeSettings = 38,
  BulkChargeType = 416,
  BulkEntitlementType = 486,
  BusinessEntities = 630,
  BusinessUnitLanguageConfiguration = 269,
  BusinessUnitSubscriberPlanSettingsConfig = 557,
  BusinessUnitTemplate = 470,
  BusinessUnitToSubscriberExtension = 160,
  BuyersRemorseConfig = 531,
  CallCategory = 613,
  CaseAssociationType = 402,
  CaseExternalReferenceType = 409,
  CasePriority = 397,
  CaseSeverity = 398,
  CaseStatus = 403,
  CatalogFeedConfiguration = 334,
  CatalogFeedType = 333,
  ChangeServiceAddressConfiguration = 748,
  ChannelBrandExternalReferenceType = 351,
  ChannelBrandListExternalReferenceType = 359,
  ChannelCategory = 427,
  ChannelExternalReferenceType = 350,
  ChargesTypes = 26,
  ChargeTiming = 550,
  ChildBundleProductSortBy = 305,
  CloseCaseReason = 749,
  ClosedCaptionSettingType = 312,
  CodeTableExternalReferenceType = 604,
  CompletionRule = 482,
  ConditionalActionConditionType = 696,
  ConditionalActionType = 697,
  Consents = 465,
  ConsentType = 464,
  ConsumptionRule = 602,
  ContactCenter = 207,
  ContactEvent = 342,
  ContactMapping = 344,
  ContactMethod = 343,
  ContentExternalReferenceType = 114,
  ContentItemType = 110,
  ContentPersonRelationship = 109,
  ContentPersonRelationshipName = 115,
  ContentPersonRole = 108,
  ContentPersonType = 111,
  ContentProviderType = 126,
  ContractExternalReferenceType = 710,
  ContractType = 706,
  ConvergentBillerBehaviorConfig = 587,
  ConvergentBillerConfigurationDetail = 368,
  CoolingPeriod = 543,
  CountryCurrency = 241,
  CouponExternalReferenceType = 218,
  CreditBureauType = 519,
  CreditCardType = 35,
  CreditClassificationConfig = 520,
  CreditReasons = 99,
  Currency = 36,
  CurrencyPrecision = 709,
  CustomBillerRuleConfiguration = 404,
  CustomerWrapUp = 518,
  DayOfMonth = 3,
  DayOfWeek = 2,
  DefaultImageUrl = 128,
  DefaultPasswordChallenge = 10,
  DefaultPreferredTaxReportingCurrencyConfig = 638,
  DefaultCreditReason = 652,
  DeliveryCapabilityGroup = 148,
  DeliveryCapabilityGroupToDeliveryCapability = 149,
  DeliveryCapabilityToBillerRuleConfiguration = 354,
  DependencyScopeType = 547,
  DepositType = 431,
  DeviceApplication = 329,
  DeviceApplicationBrowse = 330,
  DeviceApplicationCustom = 331,
  DeviceType = 151,
  DeviceTechSpecsConfig = 720,
  DeviceVersion = 313,
  CommercialDataExportEndpointType = 756,
  DirectDebitBankCodes = 457,
  DirectDebitType = 240,
  DiscountApplicationCode = 712,
  DiscountExternalReferenceType = 219,
  DiscountRemoveReason = 211,
  DiscountType = 104,
  DiscretionaryDiscountReason = 195,
  DistributionChannel = 120,
  DRMOutputProtection = 233,
  DrmTrackType = 308,
  EarlyTerminationFeeBillerRuleConfiguration = 378,
  EarlyTerminationFeeChargeType = 481,
  EmailCustomCategory = 215,
  EmailIssuePlatformType = 321,
  EmailIssueType = 181,
  EmailMessage = 17,
  EmailMessageParameter = 18,
  EmailMessageParameterTemplate = 535,
  EmailParameterTemplateType = 536,
  EmailType = 16,
  EnforceAutoPay = 725,
  EntitlementBillerRuleConfiguration = 376,
  EntitlementClass = 385,
  EntitlementContextType = 418,
  EntitlementGroup = 564,
  EntitlementRecurringPeriodType = 386,
  EntitlementSharingCategory = 546,
  EntityAdditionalProperty = 6,
  EntityGroup = 735,
  EntityGroupEntityType = 743,
  EntitySpecificationTemplate = 453,
  EntityType = 441,
  EnvironmentCopyExportEntityType = 509,
  EnvironmentCopyImportExportStatus = 511,
  EnvironmentCopySettings = 576,
  EnvironmentCopySupportedAglEntity = 653,
  ExcludeFromType = 715,
  ExternalAuthenticationProvider = 278,
  ExternalAuthorizationProvider = 230,
  ExternalAuthorizationType = 227,
  ExternalBillAlias = 224,
  ExternalBillSubType = 727,
  ExternalBillType = 223,
  ExternalGiftCardPointsConversion = 311,
  ExternalGiftCardType = 310,
  ExternalLicenseProvider = 309,
  ExternalRedemptionProviderConfiguration = 304,
  ExternalRedemptionProviderType = 303,
  FeatureConfiguration = 473,
  FeatureToggleConfig = 589,
  FeatureType = 590,
  FeatureVariant = 650,
  FinanceBillerRuleConfiguration = 497,
  FormatType = 421,
  FutureDatedOrderConfiguration = 496,
  GeneralLedgerCode = 105,
  GeneralStatus = 67,
  GiftCardConfiguration = 57,
  GiftCardType = 349,
  GiftOrderConfiguration = 298,
  GlobalDiscountQualificationMethod = 698,
  GroupingTag = 700,
  GroupingTagEntityType = 699,
  GroupOrderDisplayType = 639,
  GroupUserAssignmentType = 11,
  Hierarchy = 562,
  HierarchicalAttributeInheritanceRule = 737,
  HierarchicalAttributeReplication = 738,
  HierarchicalAttributeReplicationProcessing = 739,
  HistoryWindow = 107,
  HouseholdAccess = 2002,
  HouseholdPrivileges = 551,
  IngestionExternalSystem = 228,
  InstantMessengerType = 286,
  InteractionCategory = 13,
  InteractionType = 14,
  InvalidInventoryItemReason = 439,
  InventoryCategory = 424,
  InventoryInternalStatus = 575,
  InventoryLookupType = 516,
  InventoryProvider = 429,
  InventoryRegion = 527,
  InventoryResourceType = 755,
  InventoryState = 428,
  InventorySearchKey = 634,
  InventorySystemAction = 425,
  InventoryTypeAttributeDisplayType = 722,
  InventoryTypeExternalReferenceType = 631,
  InvisionConfiguration = 508,
  InvoiceConfiguration = 501,
  InvoiceAggregatorAggregateChargeTypeGrouping = 690,
  InvoiceDetailLevel = 448,
  InvoiceItemType = 661,
  InvoiceOutputStyle = 612,
  InvoiceSection = 614,
  InvoiceSummaryType = 692,
  ITunesMode = 296,
  KeyServerType = 503,
  Language = 188,
  LifeCycleExternalReferenceType = 566,
  LifecycleStatus = 593,
  ListType = 394,
  LivePolicy = 492,
  LocationConfiguration = 563,
  LoyaltyPointsCard = 40,
  LoyaltyPointsCardEvent = 41,
  LoyaltyPointsCardEventConfiguration = 42,
  MantleConfiguration = 340,
  MantleConfigurationField = 339,
  MantleProject = 338,
  MarketingTemplateType = 432,
  MarketingTemplateTypeAttribute = 433,
  MediaQuality = 307,
  //This code table is marked to behave like a public code table and is needed to check certain configurations hence keeping in Codetables enum.
  MicroserviceConfiguration = 10111,
  MinimumAgeCountry = 472,
  MnpConfiguration = 512,
  MnpServiceProviderConfiguration = 513,
  NetworkEventErrorClass = 436,
  NetworkEventSubType = 380,
  NetworkEventType = 379,
  NotificationCategories = 647,
  NumericRangeOperator = 414,
  OffCycleConfig = 554,
  OffCycleNonRetryableFailure = 754,
  OffCycleRenewal = 753,
  OfferingExternalReferenceType = 362,
  OfferingFacet = 358,
  OfferingFacetCategory = 357,
  OfferingPresentationPage = 369,
  OfferingPresentationPageTemplateType = 719,
  OfferType = 525,
  OneTimeBillerRuleConfiguration = 361,
  OneTimeProductRemovalReason = 271,
  OrderCancellationReason = 761,
  OrderItemChangeType = 484,
  OrderScenario = 477,
  OrderStatus = 94,
  OrderSubType = 728,
  OrderType = 96,
  PartnerTag = 90,
  PartnerType = 89,
  PasswordConfiguration = 144,
  PasswordStrength = 145,
  PaymentGatewayType = 396,
  PaymentInstrumentConfiguration = 232,
  PaymentInstrumentDirectDebitConfiguration = 243,
  PaymentInstrumentType = 34,
  PaymentInstrumentTypeCurrencyConfiguration = 242,
  PaymentManagerConfiguration = 405,
  PayPalConfiguration = 147,
  PayPalMode = 136,
  PaypalPaymentType = 225,
  PeriodType = 347,
  PersonGender = 63,
  PersonRace = 64,
  PersonSuffix = 62,
  PersonTitle = 61,
  PhysicalDeviceAssociationExternalReferenceType = 265,
  PhysicalDeviceConfiguration = 262,
  PhysicalDeviceType = 170,
  PIISettings = 762,
  PlaybackPolicy = 367,
  PlayerAdServerType = 129,
  PlayerAdSettings = 208,
  PlayerCacheClearScheduleConfiguration = 654,
  PlayerContext = 134,
  PlayerContextEmbedTag = 135,
  PlaylistExternalReferenceType = 280,
  PlayReadyPolicy = 315,
  PointOfSalePaymentType = 538,
  PolicyContentEnforcement = 483,
  PreOrderConfiguration = 326,
  PresentationType = 24,
  PricingPlanExtensionType = 25,
  PricingPlanExternalReferenceType = 28,
  PricingPlanOrderingSubtype = 485,
  PricingPlanOrderingType = 30,
  ProductBundleStructureGroup = 273,
  ProductClassification = 490,
  ProductDisplayConfiguration = 165,
  ProductExtensionType = 21,
  ProductExternalReferenceType = 27,
  ProductFacet = 295,
  ProductFacetCategory = 294,
  ProductInstancePropertyReference = 204,
  ProductInstancePropertyType = 152,
  ProductLineOfBusiness = 19,
  ProductLineOfBusinessDeliveryCapability = 20,
  ProductLineOfBusinessDeliveryCapabilityConfiguration = 143,
  ProductLineOfBusinessDeliveryCapabilityConfigurationAction = 137,
  ProductLineOfBusinessDeliveryCapabilityConfigurationToAction = 138,
  ProductLineOfBusinessDeliveryCapabilityGeneralLedgerConfiguration = 141,
  ProductLineOfBusinessDeliveryCapabilityToDevice = 153,
  ProductLineOfBusinessDeliveryCapabilityToExtension = 159,
  ProductLineOfBusinessGeneralLedgerConfiguration = 140,
  ProductLineOfBusinessServiceabilityStatus = 676,
  ProductLineOfBusinessToExtension = 158,
  ProductPricingPlanOrderScenario = 592,
  ProductPricingPlanServiceRelationship = 560,
  ProductPricingPlanServiceRelationshipLink = 561,
  ProductPurchaseDiscountType = 279,
  ProductToPricingPlanExternalReferenceType = 276,
  PurchaseOrderItemType = 54,
  QualificationType = 489,
  QuantityPricingType = 417,
  Rating = 33,
  RatingCategory = 32,
  RatingCategoryCountry = 314,
  ReasonCodes = 530,
  RecurrenceType = 320,
  RecurringBillerRuleConfiguration = 353,
  RedemptionCodeRemoveReason = 272,
  RegularExpression = 180,
  ReminderLeadInDays = 103,
  RemittanceConfiguration = 476,
  RemittanceCriteria = 479,
  RentalPolicyMessageConfiguration = 316,
  ReportFormat = 411,
  ReportScheduleFrequency = 410,
  RevokeOrderRedemptionReason = 302,
  RokuPurchaseConfiguration = 318,
  ScheduleHealth = 455,
  ScheduleType = 454,
  SearchableTag = 747,
  SecurityAttributeCategory = 231,
  SecurityAttributeType = 8,
  SecurityTargetType = 9,
  SegmentationRuleExternalReferenceType = 221,
  SegmentationRuleType = 106,
  SegmentCategory = 371,
  SegmentExternalReferenceType = 220,
  ServiceabilityAndVerification = 675,
  ServiceabilityIncludePayloads = 681,
  ServiceabilityConfiguration = 740,
  ServiceabilityInfrastructureOwner = 731,
  ServiceabilityInstallationMethod = 734,
  ServiceabilitySpeed = 732,
  ServiceabilityTechnology = 733,
  ServiceabilityWhenToVerify = 679,
  ServiceAttribute = 355,
  ServiceAttributeInternalReference = 603,
  ServiceAttributeType = 356,
  ServiceCategory = 348,
  ServiceExternalReferenceType = 352,
  ServiceType = 374,
  Session = 235,
  SettlementPolicyType = 91,
  SettlementPolicyTag = 92,
  SettlementRevenueType = 300,
  ShippingAddressProvider = 695,
  ShippingAddressType = 703,
  ShippingProvider = 213,
  ShippingProviderMethod = 214,
  ShoppingCartSettings = 585,
  StandardCurrencyCharge = 39,
  StateProvinceTaxExemptConfiguration = 56,
  StoredValueAccountAllowanceTax = 751,
  StoredValueAccountRechargeType = 58,
  StorefrontExternalReferenceType = 360,
  StorefrontLayoutType = 121,
  Stores = 528,
  StructureType = 22,
  SubscriberAccessLimitSettings = 471,
  SubscriberAnonymization = 266,
  SubscriberCategory = 449,
  SubscriberCategoryDefaultSubscriberType = 459,
  SubscriberCategoryRequirements = 451,
  SubscriberExtensionType = 65,
  SubscriberFeeEventChargeType = 685,
  SubscriberFeeExternalReferenceType = 759,
  SubscriberFeesAdditionalIdentifierType = 686,
  SubscriberIdentifications = 539,
  SubscriberIncomeLevelType = 189,
  SubscriberInput = 155,
  SubscriberLeadSourceType = 167,
  SubscriberPreferredContactType = 168,
  SubscriberProductPricingPlanChangeSource = 206,
  SubscriberRequirements = 166,
  SubscriberSearchConfig = 510,
  SubscriberState = 517,
  SubscriberType = 194,
  SubscriberTypeSecurityRole = 537,
  SubscriberValidationTypes = 540,
  SubscriptionBillerRuleConfiguration = 475,
  SubscriptionBillingCycle = 102,
  SubscriptionBillingRenewalType = 101,
  SubscriptionPolicy = 154,
  SubscriberProductCleanConfiguration = 289,
  SubscriptionStateIndicator = 558,
  SubscriptionTerminationReason = 150,
  SubtenantConfig = 586,
  SubtenantExternalReferenceType = 480,
  TaskStatus = 456,
  TaxAttributes = 249,
  TaxApplicability = 598,
  TaxInclusiveSettings = 346,
  TaxLevel = 440,
  TaxProcessorType = 175,
  TaxServiceType = 412,
  TaxTransactionType = 55,
  TaxType = 177,
  TelephoneCodes = 515,
  TelephoneNumberNpa = 635,
  TelephoneNumberNxx = 636,
  TermsAndConditionsConfiguration = 131,
  TermsAndConditionsType = 132,
  ThreeDSChallengePreference = 544,
  TimeZone = 1,
  TokenAuthenticationProvider = 420,
  TransactionCreditCardResult = 48,
  TransactionECheckResult = 47,
  TransactionExternalBillResult = 51,
  TransactionResult = 44,
  TransactionType = 43,
  TransferServiceRequestSettings = 758,
  TransitionConfiguration = 389,
  TriggerBillerRuleConfiguration = 488,
  UnitsOfMeasure = 375,
  UsageBillerRuleConfiguration = 364,
  UsageCapBehavior = 669,
  UsageCapLevelToApplyDiscount = 532,
  UsageCapMenuTitle = 506,
  UsageCapResetPeriod = 523,
  UsageCapThresholdType = 522,
  UsageChargeMetric = 381,
  UsageChargeType = 384,
  UsageRateType = 708,
  UsageNotificationType = 605,
  UsagePriceType = 383,
  UsageRateAggregationPeriod = 553,
  UsageRatePricingPeriod = 552,
  UsageRateTierPricingMethod = 726,
  UsageRuleExternalReferenceType = 629,
  UsageRuleAdditionalIdentifierType = 678,
  UsageTimeBand = 382,
  UsageUnitConversion = 565,
  UserTitle = 746,
  UserType = 713,
  ValidityPeriod = 521,
  WaiveFeeReason = 100,
  WaiveOrderContractPenaltyReason = 718,
  WashGroup = 514,
  WidevinePolicy = 274,
  WishlistNotification = 372,
  WeightedRolloutConfiguration = 649,
  Workflow = 236,
  WorkflowActivityState = 72,
  WorkflowExecutionPriority = 78,
  WorkflowType = 79,
  WorkflowValidActivityStates = 73,
  WriteOffReason = 178,
  XboxAccountType = 336,
  XboxCatalogFeedConfiguration = 341,
  XboxPurchaseConfiguration = 337,
  XboxSecurity = 335
}

export enum InternalCodeTableNumber {
  AccountUpdaterConfiguration = 10039,
  AccountUpdaterTerminalResponseAction = 10223,
  AccountUpdaterType = 10112,
  AddressValidationServiceProviderConfiguration = 10018,
  AkamaiCacheConfiguration = 10053,
  AmazonS3Configuration = 10093,
  ApiEncryptionConfigurationSettings = 10109,
  AvalaraTaxServiceConfiguration = 10105,
  AwsCredentials = 10098,
  AwsLambdaConfiguration = 10142,
  AwsLambdaExternalActionProvider = 10157,
  BatchConfiguration = 10009,
  BraintreeConfiguration = 10102,
  BraintreeMerchantConfiguration = 10103,
  BusinessUnitIdentifier = 10048,
  BusinessUnits = 10067,
  CdnDigestSettings = 10060,
  CodeDisplayOrderConfiguration = 10002,
  CodeType = 10001,
  ContentProviderKeyChest = 10032,
  ConvivaSessionViewing = 10043,
  CreditBureauAwsLambdaConfig = 10117,
  CreditBureauTransunionCredentialsConfig = 10116,
  CustomSweeperConfiguration = 10058,
  DelayedQueueProcessing = 10232,
  Deluxe = 10054,
  DisneyNautilus = 10022,
  DynamicApi = 10214,
  EmailServer = 10024,
  EventMonitorSubscription = 10128,
  EventNotificationTypeSubscription = 10090,
  ExternalDvrAwsLambda = 10131,
  ExternalOAuthProvider = 10245,
  FairPlay = 10096,
  FlashAccess = 10030,
  FraudDetectionConfiguration = 10135,
  FTPMode = 10027,
  GooglePlayConfiguration = 10079,
  HttpCredentials = 10033,
  HttpSecurityHeaders = 10242,
  IdempotencyConfiguration = 10229,
  IdentityProvider = 10106,
  IdentityProviderMember = 10107,
  InvoiceProvider = 10129,
  ITunesConfiguration = 10049,
  JSONEnabledOutput = 10064,
  KeyServer = 10140,
  KinesisEventNotificationSubscription = 10099,
  Marlin = 10041,
  MerchantConfiguration = 10010,
  MicroserviceRouting = 10147,
  MicroserviceRoutingRegex = 10148,
  MicroserviceTypeCode = 10110,
  MicroserviceTypeToPublicationType = 10153,
  OAuthClient = 10047,
  OAuthUserAuthentication = 10062,
  OfferBehavior = 10143,
  OfferBehaviorRule = 10145,
  OfferBehaviorTiming = 10144,
  OMA = 10044,
  OrderConfiguration = 10063,
  OutputSolutionConfiguration = 10130,
  PaymentInstrumentCreditCardConfiguration = 10026,
  PaymentInstrumentValidation = 10025,
  PayPalCredentials = 10015,
  PublicationType = 10152,
  QueueConfiguration = 10234,
  QuoteAndOrder = 10244,
  ReCaptcha = 10061,
  RecommendationStorefront = 10016,
  RevenueCreditCardType = 10095,
  S3FileType = 10100,
  SecurityAttribute = 10104,
  SlBosConfiguration = 10092,
  TaxProcessorConfiguration = 10056,
  TextScrubberPhrase = 10046,
  TextScrubberSearchTerm = 10013,
  TextScrubberToken = 10011,
  TextScrubberWord = 10012,
  TrustedIpAddresses = 10021,
  UrlSsoDigestSettings = 10059,
  UserSecurity = 10241,
  Widevine = 10031,
  XBOX = 10042
}

export interface CodeTableAdditionalPropertiesCommon {
  excluded_business_unit_ids?: string;
}

interface CodeTableAdditionalPropertyType {
  [CodeTableNumber.AdditionalProperty]: AdditionalPropertyOfAdditionalProperty;
  [CodeTableNumber.AdditionalPropertyGroup]: AdditionalPropertyOfAdditionalPropertyGroup;
  [CodeTableNumber.AdditionalPropertyValue]: AdditionalPropertyOfAdditionalPropertyValue;
  [CodeTableNumber.AddressCountry]: AdditionalPropertyOfAddressCountry;
  [CodeTableNumber.AddressRequirements]: AdditionalPropertyOfAddressRequirements;
  [CodeTableNumber.AddressStateProvinceRegion]: AdditionalPropertyOfAddressStateProvinceRegion;
  [CodeTableNumber.AdjustmentReason]: AdditionalPropertyOfAdjustmentReason;
  [CodeTableNumber.BusinessUnitTemplate]: AdditionalPropertyOfBusinessUnitTemplate;
  [CodeTableNumber.CodeTableExternalReferenceType]: AdditionalPropertyOfCodeTableExternalReferenceType;
  [CodeTableNumber.Consents]: AdditionalPropertyOfConsents;
  [CodeTableNumber.ContactEvent]: AdditionalPropertyOfContactEvent;
  [CodeTableNumber.ContactMapping]: AdditionalPropertyOfContactMapping;
  [CodeTableNumber.ConvergentBillerBehaviorConfig]: AdditionalPropertyOfConvergentBillerDefaultBehavior;
  [CodeTableNumber.CountryCurrency]: AdditionalPropertyOfCountryCurrency;
  [CodeTableNumber.CustomBillerRuleConfiguration]: AdditionalPropertyOfCustomBillerRuleConfiguration;
  [CodeTableNumber.DeliveryCapabilityToBillerRuleConfiguration]: AdditionalPropertyOfDeliveryCapabilityToBillerRuleConfiguration;
  [CodeTableNumber.EarlyTerminationFeeBillerRuleConfiguration]: AdditionalPropertyOfEarlyTerminationFeeBillerRuleConfiguration;
  [CodeTableNumber.EntitlementBillerRuleConfiguration]: AdditionalPropertyOfEntitlementBillerRuleConfiguration;
  [CodeTableNumber.EnvironmentCopySettings]: AdditionalPropertyOfEnvironmentCopySettings;
  [CodeTableNumber.FeatureToggleConfig]: AdditionalPropertyOfFeatureToggle;
  [CodeTableNumber.FeatureType]: AdditionalPropertyOfFeatureType;
  [CodeTableNumber.FinanceBillerRuleConfiguration]: AdditionalPropertyOfFinanceBillerRuleConfiguration;
  [CodeTableNumber.GiftCardConfiguration]: AdditionalPropertyOfGiftCardConfiguration;
  [CodeTableNumber.InteractionCategory]: AdditionalPropertyOfInteractionCategory;
  [CodeTableNumber.InteractionType]: AdditionalPropertyOfInteractionType;
  [CodeTableNumber.PaymentInstrumentConfiguration]: AdditionalPropertyOfPaymentInstrumentConfiguration;
  [CodeTableNumber.PaymentInstrumentType]: AdditionalPropertyOfPaymentInstrumentType;
  [CodeTableNumber.ProductLineOfBusiness]: AdditionalPropertyOfProductLineBusinessDeliveryCapability;
  [CodeTableNumber.ReasonCodes]: AdditionalPropertiesOfReasonCodes;
  [CodeTableNumber.RecurringBillerRuleConfiguration]: AdditionalPropertyOfRecurringBillerRuleConfiguration;
  [CodeTableNumber.RegularExpression]: AdditionalPropertyOfRegularExpression;
  [CodeTableNumber.ServiceabilityAndVerification]: AdditionalPropertiesOfServiceabilityAndVerifications;
  [CodeTableNumber.ServiceAttribute]: AdditionalPropertyOfServiceAttribute;
  [CodeTableNumber.ShippingAddressProvider]: AdditionalPropertyOfShippingAddressProvider;
  [CodeTableNumber.SubscriberIdentifications]: AdditionalPropertyOfSubscriberIdentifications;
  [CodeTableNumber.SubscriberType]: AdditionalPropertyOfSubscriberType;
  [CodeTableNumber.SubscriberTypeSecurityRole]: AdditionalPropertyOfSubscriberTypeSecurityRole;
  [CodeTableNumber.TermsAndConditionsConfiguration]: AdditionalPropertyOfTermsAndConditionsConfiguration;
  [CodeTableNumber.TermsAndConditionsType]: AdditionalPropertyOfTermsAndConditionsType;
  [CodeTableNumber.TriggerBillerRuleConfiguration]: AdditionalPropertyOfTriggerBillerRuleConfiguration;
  [CodeTableNumber.UsageBillerRuleConfiguration]: AdditionalPropertyOfUsageBillerRuleConfiguration;
  [InternalCodeTableNumber.AwsLambdaConfiguration]: AdditionalPropertyOfAwsLambdaConfiguration;
  [InternalCodeTableNumber.CodeType]: AdditionalPropertyOfCodeType;
  [InternalCodeTableNumber.MicroserviceRouting]: AdditionalPropertiesOfMicroserviceRouting;
  [InternalCodeTableNumber.QuoteAndOrder]: AdditionalPropertyOfQuoteAndOrder;
}

export type CodeTableAdditionalPropertyTypeOf<
  T extends CodeTableNumber | InternalCodeTableNumber
> = T extends keyof CodeTableAdditionalPropertyType
  ? CodeTableAdditionalPropertyType[T] & CodeTableAdditionalPropertiesCommon
  : Record<string | symbol, string> & CodeTableAdditionalPropertiesCommon;

export interface Reference {
  Value: string;
  Type: string;
}

export interface CodeTableCodeTypeOf<
  T extends CodeTableNumber | InternalCodeTableNumber
> {
  AdditionalProperties: {
    [Property in keyof CodeTableAdditionalPropertyTypeOf<T>]: string;
  };
  Description?: string;
  EnabledLanguages?: string[];
  IsGlobal?: boolean;
  Name?: string;
  Value: string;
  References?: Reference[];
}

export interface MetadataCodeTypeOf<T extends CodeTableNumber> {
  AdditionalProperties: KeyValueOf<CodeTableAdditionalPropertyTypeOf<T>>[];
  Default: boolean;
  Description: string;
  Global: boolean;
  /**The display name of the code, translated to the requested language */
  Name: string;
  /**The value of the code */
  Value: string;
}

export interface RetrieveCodesMetadataResponse<T extends CodeTableNumber> {
  ContextId: string;
  Codes: MetadataCodeTypeOf<T>[];
}

export interface MetadataCodeWithAdditionalPropertiesDictionary<
  T extends CodeTableNumber
> extends Omit<MetadataCodeTypeOf<T>, 'AdditionalProperties'> {
  AdditionalProperties: CodeTableAdditionalPropertyTypeOf<T>;
}

export interface MetadataCodeRecordWithAdditionalPropertiesDictionary<
  T extends CodeTableNumber
> {
  [key: string]: MetadataCodeWithAdditionalPropertiesDictionary<T>;
}
